import { Check, Circle } from "lucide-react";

interface StateIndicatorProps {
    isSuccessful: boolean;
    successText: string;
    warningText: string;
}

const StateIndicator = ({ isSuccessful, successText, warningText }: StateIndicatorProps) => {
    const containerStyle = isSuccessful ? "k-bg-brand-green-light k-border-brand-ai-surface" : "k-bg-brand-warning !k-border-brand-warning";
    const textStyle = isSuccessful ? "k-text-brand-teal" : "k-text-brand-warning";

    return (
        <div className={`d-flex align-items-center badge rounded-pill fw-medium px-3 py-2 gap-2 ${containerStyle}`}>
            {isSuccessful ? <Check size={13} strokeWidth={3} className="k-text-brand-teal" /> : <Circle size={13} strokeWidth={3} className="k-text-brand-warning" />}
            <span className={`text-xs font-medium ${textStyle}`} style={{ margin: "auto 0 0" }}>{isSuccessful ? successText : warningText}</span>
        </div>
    );
};

export default StateIndicator;
